import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addAppliedOffers} from "../../../offer/map/actions/add_applied_offers";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IAppDispatch} from "../../../store/store";
import {Currency} from "../../../types/Currency";
import {ViewType} from "../../../view_type/ViewType";
import {createMultipleApplications} from "../../api/create_multiple_applications";
import {applicationFormFields} from "../../constants/form/application_form_fields";
import {IApplicationAdditionalQuestionTypes} from "../../types/form/IApplicationFormAdditionalQuestionTypes";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../../types/lead/IPostMultipleApplicaitonsPayload";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {addPropertiesToStorageSentApplication} from "../application_property_storage";
import {alertFormSuccessMessage} from "../form/application_form_alert_text";
import {ApplicationSource, ApplicationSourceSection} from "../form/application_form_source";
import {getGeneratedMessage} from "../form/get_generated_message";
import {report} from "./application_multi_lead_analytics_events";
import {addOffersToStorageSentApplication} from "./get_storage_sent_applications_id_list_by";

// Data used in reporting purposes both by backend and platforms like algolytics tracker and GTM
interface IPropertyMultiApplicationMetadata {
    viewType: ViewType | null;
    source?: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    isAuthenticated: boolean;
    application: IApplicationData | null | undefined;
    refererApplicationUUID: string | undefined;
    originalFormParams: {
        rooms: number[];
        questions?: IApplicationAdditionalQuestionTypes[];
    };
    recommendationsWithPriceFilter: boolean;
    currency?: Currency;
}

interface IPropertyMultiApplicationPayload {
    recommendedProperties: (IRecommendedProperty | IPropertyDetail)[];
    formValues: IApplicationFormValues;
}

export const applicationMultiLeadSendProperty =
    (payload: IPropertyMultiApplicationPayload, metadata: IPropertyMultiApplicationMetadata, customSourceSection?: string) =>
    (dispatch: IAppDispatch): Promise<ApplicationMultiLeadRecommendedPropertyType[]> => {
        // TODO: this shouldn't be JsonValues type, refactor when migrating to rhf
        const jsonValues = toJsonValues(applicationFormFields, payload.formValues) as Pick<
            IApplicationFormValues,
            "name" | "marketing_email" | "marketing_sms"
        >;
        const source = metadata.source || ApplicationSource.RecommendedProperty;

        if ("text" in jsonValues) {
            delete jsonValues.text;
        }

        const createPayload: IPostMultipleApplicationsPayload = {
            ...jsonValues,
            home_match_trigger: true,
            referer_application_uuid: metadata.refererApplicationUUID,
            source,
            source_section: metadata.sourceSection,
            applications: payload.recommendedProperties.map((property) => ({
                property: property.id,
                text: getGeneratedMessage({
                    offerType: property.offer.type,
                    offerName: property.offer.name,
                    propertyNumber: property.number,
                    name: payload.formValues.name,
                    rooms: property.rooms,
                    area: property.area
                })
            }))
        };

        return dispatch(createMultipleApplications.initiate(createPayload))
            .unwrap()
            .then((response) => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                const applications = response.applications;

                if (!applications.filter(Boolean).length) {
                    return [];
                }

                const offerIDs = applications.reduce<number[]>((acc, application) => {
                    return application ? acc.concat(application.offer) : acc;
                }, []);

                addOffersToStorageSentApplication(
                    payload.recommendedProperties.map((property) => {
                        const offerRegion = isPropertyDetail(property) ? property.offer.region : property.region;

                        return {
                            id: property.offer.id,
                            coordinates: property.offer.geo_point.coordinates,
                            country: offerRegion.country,
                            regionId: offerRegion.id
                        };
                    })
                );

                addPropertiesToStorageSentApplication(payload.recommendedProperties.map((property) => property.id));

                if (metadata.isAuthenticated) {
                    dispatch(addAppliedOffers(offerIDs));
                }

                const createdApplications = applications.reduce<ApplicationMultiLeadRecommendedPropertyType[]>((acc, application) => {
                    if (application) {
                        const recommendedProperty = payload.recommendedProperties.find(({id}) => id === application.property);

                        report.singleApplicationSuccess(application, metadata.sourceSection, metadata.viewType);

                        if (recommendedProperty) {
                            acc.push([application, recommendedProperty]);
                        }
                    }
                    return acc;
                }, []);

                report.finishedSending(
                    ApplicationMultiLeadRecommendationType.PROPERTY,
                    createdApplications,
                    metadata.viewType,
                    "standard",
                    metadata.application,
                    metadata.recommendationsWithPriceFilter,
                    customSourceSection,
                    metadata.currency
                );

                return createdApplications;
            });
    };

function isPropertyDetail(property: IRecommendedProperty | IPropertyDetail): property is IPropertyDetail {
    return "region" in property.offer;
}
import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addAppliedOffers} from "../../../offer/map/actions/add_applied_offers";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IAppDispatch} from "../../../store/store";
import {Currency} from "../../../types/Currency";
import {ViewType} from "../../../view_type/ViewType";
import {createMultipleApplications} from "../../api/create_multiple_applications";
import {applicationFormFields} from "../../constants/form/application_form_fields";
import {IApplicationAdditionalQuestionTypes} from "../../types/form/IApplicationFormAdditionalQuestionTypes";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../../types/lead/IPostMultipleApplicaitonsPayload";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {addPropertiesToStorageSentApplication} from "../application_property_storage";
import {alertFormSuccessMessage} from "../form/application_form_alert_text";
import {ApplicationSource, ApplicationSourceSection} from "../form/application_form_source";
import {getGeneratedMessage} from "../form/get_generated_message";
import {report} from "./application_multi_lead_analytics_events";
import {addOffersToStorageSentApplication} from "./get_storage_sent_applications_id_list_by";

// Data used in reporting purposes both by backend and platforms like algolytics tracker and GTM
interface IPropertyMultiApplicationMetadata {
    viewType: ViewType | null;
    source?: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    isAuthenticated: boolean;
    application: IApplicationData | null | undefined;
    refererApplicationUUID: string | undefined;
    originalFormParams: {
        rooms: number[];
        questions?: IApplicationAdditionalQuestionTypes[];
    };
    recommendationsWithPriceFilter: boolean;
    currency?: Currency;
}

interface IPropertyMultiApplicationPayload {
    recommendedProperties: (IRecommendedProperty | IPropertyDetail)[];
    formValues: IApplicationFormValues;
}

export const applicationMultiLeadSendProperty =
    (payload: IPropertyMultiApplicationPayload, metadata: IPropertyMultiApplicationMetadata, customSourceSection?: string) =>
    (dispatch: IAppDispatch): Promise<ApplicationMultiLeadRecommendedPropertyType[]> => {
        // TODO: this shouldn't be JsonValues type, refactor when migrating to rhf
        const jsonValues = toJsonValues(applicationFormFields, payload.formValues) as Pick<
            IApplicationFormValues,
            "name" | "marketing_email" | "marketing_sms"
        >;
        const source = metadata.source || ApplicationSource.RecommendedProperty;

        if ("text" in jsonValues) {
            delete jsonValues.text;
        }

        const createPayload: IPostMultipleApplicationsPayload = {
            ...jsonValues,
            home_match_trigger: true,
            referer_application_uuid: metadata.refererApplicationUUID,
            source,
            source_section: metadata.sourceSection,
            applications: payload.recommendedProperties.map((property) => ({
                property: property.id,
                text: getGeneratedMessage({
                    offerType: property.offer.type,
                    offerName: property.offer.name,
                    propertyNumber: property.number,
                    name: payload.formValues.name,
                    rooms: property.rooms,
                    area: property.area
                })
            }))
        };

        return dispatch(createMultipleApplications.initiate(createPayload))
            .unwrap()
            .then((response) => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                const applications = response.applications;

                if (!applications.filter(Boolean).length) {
                    return [];
                }

                const offerIDs = applications.reduce<number[]>((acc, application) => {
                    return application ? acc.concat(application.offer) : acc;
                }, []);

                addOffersToStorageSentApplication(
                    payload.recommendedProperties.map((property) => {
                        const offerRegion = isPropertyDetail(property) ? property.offer.region : property.region;

                        return {
                            id: property.offer.id,
                            coordinates: property.offer.geo_point.coordinates,
                            country: offerRegion.country,
                            regionId: offerRegion.id
                        };
                    })
                );

                addPropertiesToStorageSentApplication(payload.recommendedProperties.map((property) => property.id));

                if (metadata.isAuthenticated) {
                    dispatch(addAppliedOffers(offerIDs));
                }

                const createdApplications = applications.reduce<ApplicationMultiLeadRecommendedPropertyType[]>((acc, application) => {
                    if (application) {
                        const recommendedProperty = payload.recommendedProperties.find(({id}) => id === application.property);

                        report.singleApplicationSuccess(application, metadata.sourceSection, metadata.viewType);

                        if (recommendedProperty) {
                            acc.push([application, recommendedProperty]);
                        }
                    }
                    return acc;
                }, []);

                report.finishedSending(
                    ApplicationMultiLeadRecommendationType.PROPERTY,
                    createdApplications,
                    metadata.viewType,
                    "standard",
                    metadata.application,
                    metadata.recommendationsWithPriceFilter,
                    customSourceSection,
                    metadata.currency
                );

                return createdApplications;
            });
    };

function isPropertyDetail(property: IRecommendedProperty | IPropertyDetail): property is IPropertyDetail {
    return "region" in property.offer;
}
